import SortBy, { SortByStrings } from 'enums/SortBy'

const getSortKey = (sortBy: SortByStrings) => {
  switch (sortBy) {
    case SortBy.RICHNESS:
      return 'confidenceScore -richness -timestamp'

    case SortBy.RANDOM:
      return 'hashedDocID'

    case SortBy.AUTHOR_FOLLOWER:
    case SortBy.SUBSCRIBER:
      return '-authorFollower -postEngagements -timestamp -richness'

    case SortBy.MOST_ENGAGEMENTS:
      return '-postEngagements -authorFollower -richness -timestamp'

    case SortBy.OVERALL_STAR_RATING:
      return '-overallStarRating -timestamp'

    case SortBy.OVERALL_SURVEY_SCORE:
      return '-overallSurveyScore -timestamp'

    case SortBy.NET_PROMOTER_SCORE:
      return '-netPromoterScore -timestamp'

    case SortBy.OVERALL_STAR_RATING_ASC:
      return 'overallStarRating -timestamp'

    case SortBy.OVERALL_SURVEY_SCORE_ASC:
      return 'overallSurveyScore -timestamp'

    case SortBy.NET_PROMOTER_SCORE_ASC:
      return 'netPromoterScore -timestamp'

    case SortBy.TIME:
    default:
      return '-timestamp'
  }
}

export default getSortKey
